import { useQuery } from '@tanstack/react-query'
import { settingsService } from '@/lib/services/settings'
import { isEquipmentPageOn } from '@/lib/equipmentPages'

// Which equipment pages this store shows. Shares the ['settings'] cache entry
// Layout already populates, so every call site is a cache read.
export function useEquipmentPages(): { kitchen: boolean; foh: boolean; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: settingsService.getSettings,
    staleTime: 5 * 60 * 1000,
  })
  return {
    kitchen: isEquipmentPageOn(data, 'kitchen'),
    foh: isEquipmentPageOn(data, 'foh'),
    isLoading,
  }
}
